import { atom } from "recoil";

export type ModalStateType = {
  type: "login" | "guide" | "";
  message: string;
  isOpen: boolean;
};

export const modalState = atom<ModalStateType>({
  key: "modalState",
  default: {
    type: "",
    message: "",
    isOpen: false,
  },
});
